import * as React from 'react';

import { __t, applyTranslations } from 'utils/language';
import { renderPrice } from 'utils/helper/price';

import './ccm-campaign-payments-payouts-header-details.scss';

applyTranslations(require('./ccm-campaign-payments-payouts-header-details.i18n.json'));

interface Props {
  data: {
    offerBudget: string | number,
    affiliatedCompensation: string | number
  }
}

const CcmCampaignPaymentsPayoutsHeaderDetails = ({ data }: Props) => (
  <div className="ccm-campaign-payments-payouts-header-details">
    <div>
      <span>{__t('ccm_campaign_payments_payouts_header_details.labels.budget_offer')}</span>
      <span className="ccm-campaign-payments-payouts-header-details__price">
        {
          typeof data.offerBudget === 'string'
            ? data.offerBudget
            : renderPrice(data.offerBudget)
        }
      </span>
    </div>
    <div>
      <span>{__t('ccm_campaign_payments_payouts_header_details.labels.compensation')}</span>
      <span className="ccm-campaign-payments-payouts-header-details__price">
        {
          typeof data.affiliatedCompensation === 'string'
            ? data.affiliatedCompensation
            : renderPrice(data.affiliatedCompensation)
        }
      </span>
    </div>
  </div>
);

export default CcmCampaignPaymentsPayoutsHeaderDetails;
